import { createContext, useContext, type ReactNode } from "react";
export const WorkspaceSelectorContext = createContext<ReactNode>(null);
export const useWorkspaceSelector = () => useContext(WorkspaceSelectorContext);

export const WorkspaceBreadcrumbContext = createContext<HTMLElement | null>(
  null,
);
export const useWorkspaceBreadcrumb = () =>
  useContext(WorkspaceBreadcrumbContext);
